
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _126cmsJdiepeM9YyXsZBxXgpJ5eLvKwVxb1YwojCDeLHzekDYMeta } from "/builds/poo/webshop/frontend/src/poo/app/pages/~cms.vue?macro=true";
import { default as _126plp4LabG88bK6HSOGvaLhcO0hBDOU8b4tdEGD4_zUY_AjEMeta } from "/builds/poo/webshop/frontend/src/poo/app/pages/~plp.vue?macro=true";
import { default as cartLZ_rT4t32YxDpI9FpY_G7elXrDtJRVR0IGswKhDWDUYMeta } from "/builds/poo/webshop/frontend/src/poo/app/pages/cart.vue?macro=true";
import { default as indexrGd1sY1SXpo7bzRafR7Xl6yHwcG88MOGK53HHdaHXK0Meta } from "/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-strapi/src/app/pages/index.vue?macro=true";
import { default as searchNvnX4gCFgHrhctLwh_FTqU8p2PlF_edHM95UY9eHM9YMeta } from "/builds/poo/webshop/frontend/src/poo/app/pages/search.vue?macro=true";
import { default as editxYAhptoQNTN7eBU1r3vHxLujf__QR7NjX6po_ZufaC8Meta } from "/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/edit.vue?macro=true";
import { default as indexyYY9jBRVFjQFFx8jxWO09mZnoK2MjW3IbBvq2XSF1H8Meta } from "/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/index.vue?macro=true";
import { default as newsletter2yCWJ0womp0mRVDtY0YdUFqvOZdxj4VuA1MWvs7yDawMeta } from "/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/newsletter.vue?macro=true";
import { default as _91id_93B1RyO1rk3lQZaFx8hgl2cj08_sfBUl0KzpT31x5SuXQMeta } from "/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/orders/[id].vue?macro=true";
import { default as indextS0lO35zuOPj6pva8zMdDA7GToYEDlpcavbq_j50kiQMeta } from "/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/orders/index.vue?macro=true";
import { default as indexoiR7Ojg_3JdLSx0_tzql8IDi_Bq4_CtviGCrWy8AmK8Meta } from "/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/addresses/index.vue?macro=true";
import { default as create1MFq6tbtffh_S2ElAx328xEPBjvjjChwzi7NFDJ9VZ8Meta } from "/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/addresses/create.vue?macro=true";
import { default as _91id_93eyjJcslT0qoyzrOME4QR4YcqCb1I2gJ_SdYYxXKDLv8Meta } from "/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/addresses/edit/[id].vue?macro=true";
import { default as accountMjYcvtLIeo1kJdN1NDj0l2GqGymUj0qvfySgjhPvGJ4Meta } from "/builds/poo/webshop/frontend/src/poo/app/pages/account.vue?macro=true";
import { default as preview3ejycO7Mrx0dv5Skg_yBUWaRw0M2VaaG2_XyG_ShIdQMeta } from "/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-strapi/src/app/pages/preview.vue?macro=true";
import { default as successm_swaKYpu7LSGfqz1mmltVON6suzqXMnsclu2LD04hMMeta } from "/builds/poo/webshop/frontend/src/poo/app/pages/success.vue?macro=true";
import { default as index8npI6TTaSSZTTMrzSTZgm4UzVkLi9Hzmz9kSMzd_LZ4Meta } from "/builds/poo/webshop/frontend/src/poo/app/pages/checkout/index.vue?macro=true";
import { default as paymentUSX_jTZFJ4PcRP9AbImP8h0hC5TXxXfC37wt0PYvOW4Meta } from "/builds/poo/webshop/frontend/src/poo/app/pages/checkout/payment.vue?macro=true";
import { default as shipmentSFThCjx_JZ5NDDDoJvqciCoiPJ9zf74_4n5PlLUMFpEMeta } from "/builds/poo/webshop/frontend/src/poo/app/pages/checkout/shipment.vue?macro=true";
import { default as checkoutHI_ya7frYZRgUTCrhGWUOvACw854r82OPmOlA9s7FVYMeta } from "/builds/poo/webshop/frontend/src/poo/app/pages/checkout.vue?macro=true";
import { default as wishlistVeLrsPQ0K8fUybsVacCbGdgtV2BnF9GQk8auDI7yeNYMeta } from "/builds/poo/webshop/frontend/src/poo/app/pages/wishlist.vue?macro=true";
import { default as _91_46_46_46slug_93KmVE5S9H62TGw_gMurOCXIPV6v_WDeaV6f7C19uBc0gMeta } from "/builds/poo/webshop/frontend/src/poo/app/pages/[...slug].vue?macro=true";
import { default as _126cms_45columnshGQ0riLJsZLxWad_dp3CG__GeTu9igktC8wjeyZkJKAMeta } from "/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-strapi/src/app/pages/~cms-columns.vue?macro=true";
import { default as empty_45layoutJe9pJTL7SuKkYaWm8Isnv4gnPc3pw1JPs12xKKGZfkwMeta } from "/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-base/src/nuxt3-base/app/pages/empty-layout.vue?macro=true";
import { default as _126customer_45service_Rl8RhGG3jVy_wcFyTT5IIHNbP_VGmlVe6BlGZHUGpAMeta } from "/builds/poo/webshop/frontend/src/poo/app/pages/~customer-service.vue?macro=true";
import { default as color_45palette_45generatorYqodT6cB2CzpcVnCX_ADukoXD7GSRm2iQZEwBQFvm0QMeta } from "/builds/poo/webshop/frontend/src/poo/app/pages/design-system/devs/color-palette-generator.vue?macro=true";
import { default as component_45stubv7_5zSg5GyfwN3YGMSiojbtoWKrABdwu6suhVbuEuNwMeta } from "/builds/poo/webshop/frontend/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubv7_5zSg5GyfwN3YGMSiojbtoWKrABdwu6suhVbuEuNw } from "/builds/poo/webshop/frontend/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "~cms",
    path: "/~cms",
    component: () => import("/builds/poo/webshop/frontend/src/poo/app/pages/~cms.vue")
  },
  {
    name: "~plp",
    path: "/~plp",
    component: () => import("/builds/poo/webshop/frontend/src/poo/app/pages/~plp.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/builds/poo/webshop/frontend/src/poo/app/pages/cart.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-strapi/src/app/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/builds/poo/webshop/frontend/src/poo/app/pages/search.vue")
  },
  {
    name: "account",
    path: "/account",
    component: () => import("/builds/poo/webshop/frontend/src/poo/app/pages/account.vue"),
    children: [
  {
    name: "account-edit",
    path: "edit",
    component: () => import("/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/edit.vue")
  },
  {
    name: "account-index",
    path: "",
    component: () => import("/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/index.vue")
  },
  {
    name: "account-newsletter",
    path: "newsletter",
    component: () => import("/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/newsletter.vue")
  },
  {
    name: "account-orders-id",
    path: "orders/:id()",
    component: () => import("/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders",
    path: "orders",
    component: () => import("/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/orders/index.vue")
  },
  {
    name: "account-addresses",
    path: "addresses",
    component: () => import("/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/addresses/index.vue")
  },
  {
    name: "account-addresses-create",
    path: "addresses/create",
    component: () => import("/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/addresses/create.vue")
  },
  {
    name: "account-addresses-edit-id",
    path: "addresses/edit/:id()",
    component: () => import("/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-magento2/src/app/pages/account/addresses/edit/[id].vue")
  }
]
  },
  {
    name: "preview",
    path: "/preview",
    component: () => import("/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-strapi/src/app/pages/preview.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/builds/poo/webshop/frontend/src/poo/app/pages/success.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("/builds/poo/webshop/frontend/src/poo/app/pages/checkout.vue"),
    children: [
  {
    name: "checkout-index",
    path: "",
    meta: index8npI6TTaSSZTTMrzSTZgm4UzVkLi9Hzmz9kSMzd_LZ4Meta || {},
    component: () => import("/builds/poo/webshop/frontend/src/poo/app/pages/checkout/index.vue")
  },
  {
    name: "checkout-payment",
    path: "payment",
    meta: paymentUSX_jTZFJ4PcRP9AbImP8h0hC5TXxXfC37wt0PYvOW4Meta || {},
    component: () => import("/builds/poo/webshop/frontend/src/poo/app/pages/checkout/payment.vue")
  },
  {
    name: "checkout-shipment",
    path: "shipment",
    meta: shipmentSFThCjx_JZ5NDDDoJvqciCoiPJ9zf74_4n5PlLUMFpEMeta || {},
    component: () => import("/builds/poo/webshop/frontend/src/poo/app/pages/checkout/shipment.vue")
  }
]
  },
  {
    name: "wishlist",
    path: "/wishlist",
    component: () => import("/builds/poo/webshop/frontend/src/poo/app/pages/wishlist.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/builds/poo/webshop/frontend/src/poo/app/pages/[...slug].vue")
  },
  {
    name: "~cms-columns",
    path: "/~cms-columns",
    component: () => import("/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-strapi/src/app/pages/~cms-columns.vue")
  },
  {
    name: "empty-layout",
    path: "/empty-layout",
    meta: empty_45layoutJe9pJTL7SuKkYaWm8Isnv4gnPc3pw1JPs12xKKGZfkwMeta || {},
    component: () => import("/builds/poo/webshop/frontend/node_modules/@xsarus-npm/nuxt3-base/src/nuxt3-base/app/pages/empty-layout.vue")
  },
  {
    name: "~customer-service",
    path: "/~customer-service",
    component: () => import("/builds/poo/webshop/frontend/src/poo/app/pages/~customer-service.vue")
  },
  {
    name: "design-system-devs-color-palette-generator",
    path: "/design-system/devs/color-palette-generator",
    component: () => import("/builds/poo/webshop/frontend/src/poo/app/pages/design-system/devs/color-palette-generator.vue")
  },
  {
    name: component_45stubv7_5zSg5GyfwN3YGMSiojbtoWKrABdwu6suhVbuEuNwMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubv7_5zSg5GyfwN3YGMSiojbtoWKrABdwu6suhVbuEuNw
  }
]